<template>
  <div>
    <div class="image-wrapper" @click="showModal = true">
      <div class="play-button-overlay">
        <div class="play-icon icon-icon_play btn-outline-primary"></div>
      </div>
      <img
        src="../assets/video_img.png"
        alt="video image"
        width="100%"
        height="100%"
      />
    </div>
    <Modal v-model="showModal" :width="80" :footer-hide="true">
      <iframe
        v-if="showModal"
        width="98%"
        :height="videoHeight"
        src="https://www.youtube.com/embed/Eg99Y4q5Yws"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    videoHeight() {
      const scaleWidth = window.innerWidth * 0.6;
      const scaleHeight = Math.round((scaleWidth * 3) / 4);
      return scaleHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 100%;
  position: relative;
  cursor: pointer;

  .play-button-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .play-icon {
    border: 2px solid;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    display: flex;
    background: white;
    box-shadow: 0px 3px 6px 0 grey;
    cursor: pointer;
    @media screen and (max-width: 528px) {
      width: 4rem;
      height: 4rem;
    }

    &.icon-icon_play:before {
      flex: 1;
      align-self: center;
      text-align: center;
      transform: scale(4);

      @media screen and (max-width: 528px) {
        transform: scale(1.5);
      }
    }
  }
}
</style>
